<section class="w-full flex flex-wrap content-start">
  <article class="w-full">
    <!-- ? Header -->
    <header class="w-full h-14 mb-4 flex flex-wrap items-center justify-between border-b border-gray-100 dark:border-gray-600 overflow-hidden relative">
      <!--? Header Main section  -->
      <section class="w-full flex px-2 md:px-4 justify-center duration-200 absolute right-0" [ngClass]="displaySearchBar ? 'opacity-100 z-10 delay-75' : 'opacity-0'">
        <!-- ? Back Button -->
        <div class="w-3/12 items-center">
          <button class="flex justify-center h-10 px-4 items-center text-gray-900" (click)="_location.back()">
            <span class="icon chevron-right-regular text-lg"></span>
          </button>
        </div>

        <!-- ? Library Owner Name -->
        <div class="w-6/12 flex items-center justify-center">
          <p class="text-xs md:text-base font-medium text-gray-900">
            {{ userName ? "کتابخانۀ " + userName : "کتابخانه" }}
          </p>
        </div>

        <!--? Search Icon  -->
        <div class="w-3/12 flex justify-end items-center"></div>
      </section>

      <!-- ? Search Section -->
      <section class="w-full flex px-2 md:px-4 items-center duration-200 absolute right-0" [ngClass]="displaySearchBar ? 'opacity-0' : 'opacity-100 z-10 delay-75'">
        <div class="w-11/12 flex">
          <input
            type="text"
            class="transition border-none focus:outline-none focus:ring-0 w-full bg-gray-100 text-gray-500"
            placeholder="جست‌و‌جو در کتابخانه"
            #search
            (keyup.enter)="searchBook(search.value)"
            id="librarySearchInput" />
        </div>

        <div class="w-1/12 flex justify-end items-center">
          <button class="icon-btn" (click)="displaySearchBar = true">
            <span class="icon dismiss-regular text-base"></span>
          </button>
        </div>
      </section>
    </header>

    <main class="w-full flex flex-wrap px-4 h-fit">
      <ng-container *ngIf="!loading && _localRepository.IsInBrowser; else skeleton">
        <!-- ? All books -->
        <div class="w-full flex flex-wrap">
          <!-- ? Shelves Header -->
          <div class="w-full mb-4 flex items-center justify-between">
            <p class="text-base font-medium text-gray-500">قفسه‌ها</p>
            <ng-container *ngIf="libraryOwner">
              <button class="flex justify-center items-center" (click)="addNewShelf()">
                <span class="icon add-regular text-sm text-gray-900"></span>
                <span class="text-sm mr-2 text-gray-900"> افزودن قفسۀ جدید </span>
              </button>
            </ng-container>
          </div>
          <!-- ? All Books Header -->
          <a class="cursor-pointer w-full flex flex-wrap" [routerLink]="[routes.library_book, userId]" [queryParams]="{ shelfOwner: userName, shelfName: 'همۀ کتاب‌های ' }">
            <div class="w-1/2 flex items-center">
              <p class="text-base font-medium text-gray-700">همۀ کتاب‌ها</p>
            </div>
            <div class="w-1/2 flex items-center justify-end">
              <p class="text-sm text-gray-400 cursor-pointer flex items-center">
                {{ totalBooksCount || 0 | number }}
                <span class="icon chevron-left-regular text-lg text-gray-400"></span>
              </p>
            </div>
          </a>
        </div>

        <!-- ? Default shelves -->
        <div class="w-full mt-4 flex gap-1 md:gap-2">
          <app-library-shelf class="w-4/12" *ngFor="let shelf of defaultShelves$ | async" [shelf]="shelf" [userId]="userId"> </app-library-shelf>
        </div>

        <!-- ? User Shelves -->
        <div class="w-full my-4 border-b border-gray-100 dark:border-gray-600 flex flex-wrap items-center justify-between">
          <ng-container *ngIf="userShelves?.length > 0; else noShelf">
            <div class="w-full flex flex-wrap items-center justify-center md:justify-start mt-4 md:mt-0">
              <button class="ml-4 text-green-500 hover:bg-green-10 dark:hover:bg-green-1000" (click)="setFilterDirection()" [ngClass]="{ 'rotate-y-180': filterDirection == 1 }">
                <span
                  class="icon text-xl"
                  [ngClass]="{
                    'arrow-sort-up-lines-regular': filterDirection == 1,
                    'arrow-sort-down-lines-regular': filterDirection == 0,
                  }"></span>
              </button>
              <ng-container *ngFor="let btn of filterButtons">
                <button
                  class="ml-4 !text-xs md:text-sm text-green-500 h-9 py-2 px-3 md:px-5 rounded-3xl border border-green-500 hover:bg-gray-50 dark:bg-gray-900"
                  [ngClass]="{
                    '!text-gray-300 !border-gray-100 dark:!border-gray-600': sortFilter != btn.value,
                  }"
                  (click)="filterShelves(btn.value)">
                  {{ btn.title }}
                </button>
              </ng-container>
            </div>

            <div class="w-full flex flex-wrap">
              <!-- ? Shelves -->
              <div class="w-full">
                <ng-container *ngFor="let shelf of userShelves">
                  <a
                    [routerLink]="[routes.library_book, userId]"
                    [queryParams]="{
                      shelfId: shelf.id,
                      shelfName: shelf.title,
                      shelfOwner: userName,
                    }"
                    class="w-full my-2 flex items-center justify-between cursor-pointer h-10 hover:scale-95 group transition-all">
                    <div class="col pl-2 flex">
                      <p class="text-sm text-gray-400 cursor-pointer line-clamp-1 group-hover:text-gray-900 dark:group-hover:text-gray-50 transition-all">
                        {{ shelf.title }}
                      </p>
                    </div>
                    <p class="text-sm text-gray-400 cursor-pointer flex items-center group-hover:text-gray-900 dark:group-hover:text-gray-50 transition-all">
                      {{ shelf.booksCount || 0 | number }}
                      <span class="icon chevron-left-regular text-lg text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-50 transition-all"></span>
                    </p>
                  </a>
                </ng-container>
              </div>
              <!-- ? Load More Shelves -->
              <ng-container *ngIf="userHasMoreShelves">
                <div class="w-full my-2 flex items-center justify-center">
                  <button class="text-xs md:text-sm bg-blue-50 text-blue-500 w-full h-10 p-2 rounded-lg" (click)="loadMoreUserShelves()" [appButtonLoader]="loadingMoreShelves">بیشتر</button>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <!-- ? Read Books -->
        <ng-container *ngIf="libraryOwner && !loading">
          <div class="w-full pb-4 mb-4 flex flex-wrap border-b border-gray-100 dark:border-gray-600">
            <p class="text-gray-500 text-base font-medium w-full">یادداشت بنویس.</p>
            <p class="text-sm text-gray-500 py-2">برای کتاب‌هایی که خوانده‌ای یادداشت بنویس.</p>

            <!-- ? Read Books Without Review -->
            <ng-container *ngIf="booksWithoutReview$ | async as booksWithoutReview">
              <div class="w-full">
                @if (booksWithoutReview?.length > 0) {
                  <swiper-container class="w-full pb-6 !pt-12 flex" navigation="true" slides-per-view="auto"  observer="true" observe-parents="true" lazy="true">
                    @for (book of booksWithoutReview | slice: 0 : 5; track $index; let i = $index) {
                      <swiper-slide class="w-full md:w-[328px] flex pb-4 ml-4">
                        <app-behkhaan-book-card class="w-full flex pb-4 ml-4" [_book]="book" [_horizontal]="true"> </app-behkhaan-book-card>
                      </swiper-slide>
                    }
                  </swiper-container>
                } @else {
                  <div class="w-full flex flex-col justify-center items-center p-5">
                    <span class="icon book-open-regular text-xl text-gray-500"></span>
                    <p class="text-base text-gray-500 text-center">در حال حاضر شما کتابی نخوانده‌اید</p>
                  </div>
                }
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </main>
  </article>
</section>

<!-- ? Skeleton -->
<ng-template #skeleton>
  <div class="w-full px-2">
    <div class="mb-1">
      <ngx-skeleton-loader [theme]="{ width: '100%', height: '32px' }"></ngx-skeleton-loader>
    </div>
    <ngx-skeleton-loader [theme]="{ width: '100%', height: '48px' }"></ngx-skeleton-loader>
  </div>
  <div class="w-full flex mb-4">
    <ng-container *ngFor="let item of [0, 1, 2]">
      <div class="w-4/12 px-2 flex flex-wrap justify-center">
        <ngx-skeleton-loader class="w-full h-[280px] max-h-[280px]" [theme]="{ height: '100%' }"> </ngx-skeleton-loader>
        <ngx-skeleton-loader class="w-full mt-4" [count]="2" [theme]="{ height: '12px' }"> </ngx-skeleton-loader>
      </div>
    </ng-container>
  </div>
  <ng-container *ngFor="let item of [0, 1, 2, 3, 4, 5]">
    <div class="w-full flex justify-between">
      <ngx-skeleton-loader [theme]="{ height: '12px', width: '100px' }"> </ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '30px', width: '40px' }"> </ngx-skeleton-loader>
    </div>
  </ng-container>

  <div class="w-full flex flex-wrap">
    <ngx-skeleton-loader class="w-full" [theme]="{ height: '16px', width: '100px' }"> </ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '12px', width: '200px' }"> </ngx-skeleton-loader>
  </div>

  <div class="w-full flex overflow-hidden">
    <ng-container *ngFor="let item of [0, 1]">
      <div class="w-9/12 lg:6/12 flex justify-between items-center mb-1 border-input py-2">
        <div class="flex items-center">
          <ngx-skeleton-loader count="1" [theme]="{ height: '96px', width: '64px' }"> </ngx-skeleton-loader>
          <div class="pr-4 flex flex-wrap">
            <div class="w-full">
              <ngx-skeleton-loader count="1" [theme]="{ height: '15px' }"> </ngx-skeleton-loader>
            </div>
            <div class="w-full flex flex-wrap">
              <ngx-skeleton-loader class="w-full" count="1" [theme]="{ height: '10px', width: '100px' }"> </ngx-skeleton-loader>
              <ngx-skeleton-loader count="1" [theme]="{ height: '10px', width: '100px' }"> </ngx-skeleton-loader>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- ? No Shelf -->
<ng-template #noShelf>
  <div class="w-full flex flex-col justify-center items-center p-5">
    <span class="icon library-regular text-xl text-gray-500"></span>
    <p class="text-base text-gray-500 text-center">قفسه‌ای وجود ندارد.</p>
  </div>
</ng-template>

<!-- ? No Read Book Without Review -->
<ng-template #noReadBook>
  <div class="w-full flex flex-col justify-center items-center p-5">
    <span class="icon book-open-regular text-xl text-gray-500"></span>
    <p class="text-base text-gray-500 text-center">در حال حاضر شما کتابی نخوانده‌اید</p>
  </div>
</ng-template>
